import PendingJobDetail from './styled';

export default PendingJobDetail;
